import * as React from 'react'
import {useForceUpdate} from '../hooks'
import {ComponentUpdater} from './index'

export const withUpdaters =
  (...updaters: ComponentUpdater[]) =>
  <T>(Component: React.ComponentType<T>) =>
  (props: T) => {
    let mounted = true
    const data: any[] = []
    const forceUpdate = useForceUpdate()
    React.useEffect(() => {
      updaters.forEach((u, ix) => {
        data[ix] = u.onMount(() => {
          if (mounted) {
            forceUpdate()
          }
        })
      })
      return () => {
        mounted = false
        updaters.forEach((u, ix) => {
          u.onUnmount(data[ix])
        })
      }
    }, [])
    return React.createElement(Component, props)
  }
